import { useContext } from "react"

import { SplashScreenContext } from "./SplashScreenContext"

export const useSplashScreen = () => useContext(SplashScreenContext)
